<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small"><div class="inner"><i class="ti ti-archive"></i></div></div>
    <span class="title ms-2">Envoyer un fichier d'archive</span>
  </div>
  <div class="actions d-flex align-items-center me-3">

  </div>
</div>
<form class="modal-content" id="upload-form" [formGroup]="uploadForm" (ngSubmit)="upload()">
  <div class="d-flex flex-column gap-3 w-100">
    <div class="form-group w-100">
      <label class="form-label required">Fichier</label>
      <input type="file" (change)="loadFile($event)" accept=".zip" class="form-control" [class.is-invalid]="uploadForm.get('file').invalid && uploadForm.get('file').touched">
    </div>
  </div>
</form>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" form="upload-form" type="submit" [disabled]="uploadForm.invalid">Valider</button>
</div>
